import { render } from "./Dashboard.vue?vue&type=template&id=25d4809e"
const script = {}
script.render = render

export default script